import React from 'react';

const NoHeaderLayout = ({ children }) => {
  return (
    <div>
      {children}
    </div>
  );
};

export default NoHeaderLayout;